import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOItem } from "../../models/BOItem.model";
import { BOOdontologyBackgroundType } from "../../models/odo/BOOdontologyBackgroundType.model";
import { BOFilter } from "../../models/BOFilter";
import { BOToothOdontograma } from "../../models/odo/BOToothOdontograma.model";

@Injectable({
  providedIn: 'root'
}

)
export class ToothOdontogramaService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ToothOdontograma/';

    constructor(private http:HttpClient){}


    createOdontograma(clinicHistoryId:number,personId:number):Observable<number>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        // Enviar un objeto vacío como cuerpo, ya que la información importante está en la URL
        const body = JSON.stringify({});
        return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'createOdontograma/'+ clinicHistoryId + '/' + personId, body, httpOptions);
    }

    getOdontogramaIdByChIdAndPersonId(clinicHistoryId:number,personId:number):Observable<number>{
        return this.http.get<number>(this.myAppUrl + this.myApiUrl + 'getOdontogramaIdByChIdAndPersonId/'+ clinicHistoryId + '/' + personId);
    }


    getOdontogramas(filter:BOFilter):Observable<BOToothOdontograma[]>{
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<BOToothOdontograma[]>(this.myAppUrl + this.myApiUrl + 'getOdontogramas',body,httpOptions);
  }

}
